import { render } from "./OJTCriteria.vue?vue&type=template&id=eb8de864"
import script from "./OJTCriteria.vue?vue&type=script&lang=js"
export * from "./OJTCriteria.vue?vue&type=script&lang=js"

import "./OJTCriteria.vue?vue&type=style&index=0&id=eb8de864&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__